import { createStrictContext } from "../GangPage/createStrictContext.ts";
import type { OnboardingManager } from "./OnboardingCard.tsx";

export const [OnboardingContext, useOnboardingContext] =
  createStrictContext<OnboardingManager>();
